import { useSelector } from 'react-redux'
import { AppStateType } from '../store/types'

export const useMobileUi = (): boolean => {
  return useSelector((state: AppStateType) => state.ui.layoutType === 'mobile')
}
